import type from '@/helpers/rave/constants/types'

export default {
  [type.GENERATOR]: 'Frustration',
  [type.MAN_GENERATOR]: 'Frustration',
  [type.MANIFESTOR]: 'Anger',
  [type.PROJECTOR]: 'Bitterness',
  [type.REFLECTOR]: 'Disappointment'
}
